module.exports = __webpack_public_path__ + "static/img/05wypelniijkolorem.edcc5183.png";